// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"a7a5f679","344":"d09e593b","369":"8a8db4e1","486":"11aa0fec","667":"5a499bf9","977":"40762712"}[chunkId] + ".chunk.js";
};